import { parsePhoneNumber } from 'awesome-phonenumber';
/**
 * Parses the input phone number and returns its country region.
 * Example:'+4581827914' => 'dk'
 *
 * @param e164_format The phone number.
 */
export function getCountryCodeFromPhoneNumber(e164_format) {
    try {
        const phoneNumber = parsePhoneNumber(e164_format || '');
        if (phoneNumber.regionCode) {
            return phoneNumber.regionCode.toLowerCase();
        }
    }
    catch (error) {
        return undefined;
    }
}
/**
 * Converts a phone number in string to E164 format
 *
 * @param number Phone number string
 */
export const formatE164 = (number) => {
    var _a;
    try {
        const phoneNumber = parsePhoneNumber(number || '');
        return (_a = phoneNumber.number) === null || _a === void 0 ? void 0 : _a.e164;
    }
    catch (error) {
        return undefined;
    }
};
/**
 * Converts a phone number in string to International format
 *
 * @param number Phone number string
 */
export const formatInternational = (number) => {
    var _a;
    try {
        const phoneNumber = parsePhoneNumber(number || '');
        return (_a = phoneNumber.number) === null || _a === void 0 ? void 0 : _a.international;
    }
    catch (error) {
        return undefined;
    }
};
/**
 * Parses the input phone number and returns its country code.
 * Example:'+4581827914' => 45
 */
export const getPhoneNumberCountryCodeAsNumber = (number) => {
    try {
        const phoneNumber = parsePhoneNumber(number || '');
        return phoneNumber.countryCode;
    }
    catch (error) {
        return undefined;
    }
};
/**
 * Parses the input phone number and returns its country code.
 * Example:'+4581827914' => '+45'
 */
export const getPhoneNumberCountryCodeFormatted = (number) => {
    const countryCode = getPhoneNumberCountryCodeAsNumber(number);
    return countryCode ? `+${countryCode}` : undefined;
};
/**
 * Parses the input phone number and returns nationality (significant) part of
 * the number.
 */
export const getPhoneNumberNationalNumber = (number) => {
    var _a;
    try {
        const phoneNumber = parsePhoneNumber(number || '');
        if ((_a = phoneNumber.number) === null || _a === void 0 ? void 0 : _a.significant) {
            return parseInt(phoneNumber.number.significant, 10);
        }
    }
    catch (error) {
        return undefined;
    }
};
/**
 * Checks wheter a number is valid or not. The input number can be in
 * International, National and E.164 formats.
 */
export const isValidPhoneNumber = (number) => {
    try {
        const phoneNumber = parsePhoneNumber(number || '');
        return phoneNumber.valid;
    }
    catch (error) {
        return false;
    }
};
/**
 * Checks wheter a number is possible or not. The input number can be in
 * International, National and E.164 formats.
 */
export const isPossiblePhoneNumber = (number) => {
    try {
        const phoneNumber = parsePhoneNumber(number || '');
        return phoneNumber.possible;
    }
    catch (error) {
        return false;
    }
};
export const validatePossibleNumberWithReason = (number) => {
    if (isPossiblePhoneNumber(number) && isValidPhoneNumber(number)) {
        return ValidationResult.IS_POSSIBLE;
    }
    try {
        const phoneNumber = parsePhoneNumber(number || '');
        return phoneNumber.possibility;
    }
    catch (error) {
        return ValidationResult.UNKNOWN;
    }
};
export const ValidationResult = {
    IS_POSSIBLE: 'is-possible',
    INVALID_COUNTRY_CODE: 'invalid-country-code',
    TOO_SHORT: 'too-short',
    TOO_LONG: 'too-long',
    UNKNOWN: 'unknown',
};
//# sourceMappingURL=phone.js.map